<template>
  <v-flex class="admin-page" >    
    <router-view />      
  </v-flex>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { SecurityItemsKeys } from '@/enum/SecurityItems';

@Component({
  name: 'Maintenance', 
})
export default class App extends Vue {  

  beforeRouteEnter(to:any,from:any,next:any) {        
     next((vm:App) => {              
       next(vm.$store.myGetters.userSecurity[SecurityItemsKeys.HOME_ADMINISTRATION].enable?'':'/login')
     })
  }

  mounted(){
    this.$vuetify.theme.primary = '#00C853'
    this.$vuetify.theme.secondary = '#ec7404'    
  }

}
</script>

<style>

  .admin-page{
    background-color:#ddd;
    display: flex;
    flex-direction: column;    
    position: absolute;
    top:0px;
    bottom: 0px;
    left:0px;
    right: 0px;
  }
</style>